// extracted by mini-css-extract-plugin
module.exports = {"container":"Heading-module--container--2T7pl","page":"Heading-module--page--kor8I"};